import { css } from "@emotion/react";
import { colors } from "@mytutor/shared-react-web-components/lib/theme";
import parse from "html-react-parser";

const TutorFooter = ({ metadata }) => {
  if (!metadata.footerDescription) {
    return null;
  }

  const tutorFooterStyle = css`
    text-align: center;

    h2 {
      font-weight: 300;
    }
    p {
      line-height: 1.5em;
      margin: 1em 0;
      color: ${colors.neutral6};
      white-space: pre-line;
    }
  `;
  {
    const parsedContent = parse(metadata.footerDescription);
    return (
      <div className={"row"} css={tutorFooterStyle}>
        <h2>{metadata.footerTitle}</h2>
        <p>{parsedContent}</p>
      </div>
    );
  }
};

export default TutorFooter;
